module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row no-gutters feature-popup-video-row">\n<video id="video-player"\n      class="video-js"\n      controls\n      autoplay\n      preload="auto"\n      data-setup=\'{}\'>\n      <source src="'+
((__t=( videoUrl ))==null?'':__t)+
'" type="video/mp4"></source>\n      <p class="vjs-no-js">\n      To view this video please enable JavaScript, and consider upgrading to a\n      web browser that\n      <a href="http://videojs.com/html5-video-support/" target="_blank">\n        supports HTML5 video\n      </a>\n      </p>\n</video>\n</div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/video-player/video-player.html
 ** module id = 195
 ** module chunks = 1 2 3 4 5 6 10 11 20 53 120 196
 **/